document.addEventListener( "hassubscription", RenderSummary );

document.addEventListener( "nosubscription", RenderSummary );

/**
 * Render tmp-thank-you layout if user is logged in else remove preloader
 */
function RenderSummary() {
	let preloader = document.querySelector( ".js-thank-you-preloader" ),
		status = document.querySelector( ".js-thank-you-status" ),
		top = document.querySelector( ".js-thank-you-block-top" ),
		bottom = document.querySelector( ".js-thank-you-block-bottom" );

	if ( window.UserProfile.has_subscription ) {
		top.classList.add( "has-access" );
		status.textContent = "Active";
		status.classList.remove( "text-yellow" );
		status.classList.add( "text-green" );
		bottom.classList.remove( "d-none" );
	}

	preloader.classList.remove( "is-loading" );
}